import React from 'react';

export const DynamicBreadcrumb = ({ match, label, matchParam, prefix }) => {
  const labelToShow = label ? <span>{label}</span> : match.params[matchParam];
  return prefix ? (
    <span>
      {prefix} {labelToShow}
    </span>
  ) : (
    labelToShow
  );
};
